/*
 * @Description:
 * @Author: kai.zhou
 * @Date: 2020-04-01 16:27:02
 * @LastEditors: Mayer
 * @LastEditTime: 2024-10-08 16:15:56
 */
export default {
  lang: "英语",
  landing: {
    name1: "Carlcare খুলুন",
    name2: "সংরক্ষণ করুন",
    name3: "Carlcare এর সাথে, আপনি আপনার অর্ডার যেকোনো সময়ে দেখতে পারেন।",
    name4: "",
    name5: "ডানে স্লাইড করুন",
    name6: "যাচাইকরণ সম্পন্ন হয়েছে",
        name8: "Replace with Original & Guaranteed Battery", // 活动标题 副标题
    name9: "What is Flat Price Battery Replacement ?", // 标题
    name10: "The flat-price battery replacement service is designed for out-of-warranty Infinix/Tecno/itel designated models.",
    name11: "Starting from Rp.120K, you can get your battery replaced with no labor fee.",
    name12: 'Click the link to make a reservation or visit designated service centers to enjoy this hassle-free service.', // 小字标注
    name13: "Why Choose Carlcare Flat-Price Battery Replacement?",
    name14: "Original and Reliable",
    name15: "100% official spare parts perfectly fit your device.",
    name16: "Lower and Transparent Pricing",
    name17: "Enjoy a fixed, discounted price for the battery with no labor fee.",
    name18: "3-Month Warranty",
    name19: "Enjoy worry-free usage with a dependable warranty.",
    name20: "Fast and Easy On-Site Service",
    name21: "Quick and convenient battery replacement done face-to-face.",
    name22: "Worry-Free Repairs",
    name23: "Professional repairs with guaranteed long-lasting quality.",
    // name24: "1. Period: 2025.Jun9th-2025.Aug9th.",
    name25: "1. The replaced battery under this promotion comes with a 3-month official warranty.",
    name26: "2. This promotion is applicable for out-of-warranty battery replacements only.",
    name27: "3. If you join the flat-price battery promotion, you need agree to recycle the replaced original battery at the service center.",
    name28: "4. This promotion cannot be combined with other offers. Limited stock, while supplies last.",
    name29: "5. The promotion is currently available at selected stores only. For more details, please refer to the specific service locations.",
    name30: "6. Carlcare reserves the right to modify the promotion based on actual circumstances. For inquiries or assistance, please call Carlcare hotline at 02150880282.",
    name31: "Rules",
    name32: "Flat Price Battery",
    name33: "Replacement",
    name34: "From Rp120.000",
    name35: "Battery Price List",
    name36: "Brand",
    name37: "Series",
    name38: "Model",
    name39: "Price",
        name40: "Exclusive for",
    name41: "Jakarta Pusat!",
    name42: "Reservation Now",
    name43: "What is Carlcare Home Service ?",
    name44: "1.Carlcare Home Service is available for TECNO, Infinix, and itel users.",
    name45: "2.Enjoy convenient and efficient repair services anywhere (at home, in the office, at a café, on campus, or outdoors), saving you time and effort.",
    name46: "Why do we recommend choosing Carlcare Home Service ?",
    name47: "Free Home Service Charges",
    name48: "No home service fees required.",
    name49: "*For out of warranty or accidental damage, pay for parts and labor.",
    name50: "Easy Booking",
    name51: "Easily book through Carlcare App, website, hotline, or WhatsApp.",
    name52: "Safe & Reliable",
    name53: "With strict safety measures, ensuring your device is in trusted hands.",
    name54: "Official Support",
    name55: "All repairs by Carlcare official engineers use only original spareparts.",
    name56: "Ways to Book Carlcare Home Service",
    name57: "1. Open the Carlcare App",
    name58: '2. Tap "Reservation"',
    name59: '3. Choose "Carlcare Home Service"',
    name60: "4. Select your current location",
    name61: "5. Fill in the required details to complete the reservation",
    name62: "1. Open the Carlcare Official Website:https://www.carlcare.com/id/",
    name63: '2. Tap "Perbaiki Telepon"',
    name64: '3. Choose "Carlcare Home Service"',
    name65: "4. Select your current location",
    name66: "5. Fill in the required details to complete the reservation",
    name67: "Call Carlcare hotline: 021 5088 0282 to book Carlcare Home Service.",
    name68: "Contact Carlcare WhatsApp Business Account:+62-812-9009-0559 to Carlcare Home Service.",
    name69: "1.Device needs repair.",
    name70: "2.Book Carlcare Home Service.",
    name71: "3.Engineer contacts you to confirm the appointment time.",
    name72: "4.Engineer arrives at the scheduled time.",
    name73: "5.Complete the repair and make the payment.",
    name74: "Statement:",
    name75: "1.Free Home Service applies to service fees only. ",
    name76: "①Under Warranty: Enjoy free home service and repairs;",
    name77: "②Out of Warranty:Only pay for labor and spareparts,no extra home service charges.",
    name78: "2.Carlcare Home Service is currently limited to the the Jakarta Pusat and will gradually expand to more regions in the future. Please Stay tuned!",
    name79: "3.The final explanation of the activity belongs to Carlcare.",
    name80: "Carlcare App",
    name81: "Carlcare Website",
    name82: "Carlcare Hotline",
    name83: "Carlcare WhatsApp",
    name84: "No door-to-door fee",
    name85: "Service Process:",
  },
  order: {
    name1: "ডিভাইসের মডেল নির্বাচন করুন",
    name2: "সমস্যার বিবরণ:",
    name3: "পরিষেবা স্টোর নির্বাচন করতে ট্যাপ করুন",
    name4: "পরিষেবা স্টোর:",
    name5: "সংরক্ষণের সময়:",
    name6: "অনুগ্রহ করে আপনার ডিভাইসটির সমস্যা বিশদে জানান!",
    name7: "আগমনের সময় নির্বাচন করতে ট্যাপ করুন",
    name8: "অনুগ্রহ করে আপনার সাথে যোগাযোগের সঠিক তথ্য দিন যাতে আমরা আপনার সাথে যোগাযোগ করতে পারি",
    name9: "নিম্নলিখিত রিজার্ভেশনের সময় উপলব্ধ",
    name10: "অনুগ্রহ করে আপনার ফোন নাম্বারটি প্রবেশ করান",
    name11: "মূল্য",
    name12: "ব্যক্তিগত তথ্য:",
    name13: "দয়া করে আপনার নাম লিখুন",
    name14: "জমা দিন",
    name15: "বাতিল করুন",
    name16: "ঠিক আছে",
  },
  shops: {
    name1: "আপনার নির্বাচন করা ব্র্যান্ডের ভিত্তিতে, নিম্নলিখিত স্টোরগুলি আপনাকে পরিষেবা দিতে পারে!",
    name2: "আরও অনেক খুচরো বিক্রেতার দোকানে আসছে! আমাদের সাথে থাকুন!",
  },
  price: {
    name1: "মার্কা",
    name2: "মডেল",
    name3: "পদ",
    name4: "মূল্য",
    name5: "বন্ধুত্বপূর্ণ অনুস্মারক:",
    name6: "এই মূল্যগুলি আনুমানিক, এবং আসল মূল্য আপনার ডিভাইসের অবস্থার উপরে নির্ভরশীল।",
    name7: "কোনও বিশেষ চিহ্ন না থাকলে, মূল্যের একক হল স্থানীয় মুদ্রার মান।",
    name8: "দুঃখিত! বর্তমান এই অঞ্চলে কোনো মূল্যের তথ্য নেই।",
    name11:"শ্রমিকের খরচ",
    name12:"মোট দাম",
    name13: "5. শ্রমিকের খরচ যদি \"/\" হয়, তার মানে স্টোরের সাথে শ্রমিকের খরচ পরামর্শ করে নেয়া প্রয়োজন।",
    item_main_board: "মেইনবোর্ড",
    item_screen_frame: "স্ক্রিন (ফ্রেম)",
    item_screen_screen_frame: "সেকেন্ডারি স্ক্রিন (ফ্রেম) ",
    item_touch_screen: "টাচ স্ক্রিন ",
    item_camera: "ক্যামেরা",
    item_fixed_focus_camera: "স্থির ফোকাস ক্যামেরা",
    item_auto_focus_camera: "অটো ফোকাস ক্যামেরা",
    item_screen: "স্ক্রিন",
    item_secondary_screen: "সেকেন্ডারি স্ক্রিন ",
    item_fingerprint_module: "ফিঙ্গারপ্রিন্ট মডিউল ",
    item_speaker: "স্পিকার ",
    item_receiver: "রিসিভার",
    item_small_board: "ছোট বোর্ড",
    item_battery_cover: "ব্যাটারি কভার",
    item_battery: "ব্যাটারি",
    item_charger: "চার্জার",
    item_usb_cable: "ইউএসবি কেবল",
    item_lcd: "LCD",
  },
  shopDetails: {
    name1: "কোন ডেটা নেই",
    name2: "পরিষেবা প্রদানকারী:",
    name3: "সেবার ব্যান্ড:",
    name4: "টেলিফোন:",
    name5: "অর্ডারের পরিমাণ:",
    name6: "পরিষেবার রেটিং",
    name7: "পরিষেবার পরিবেশ:",
    name8: "পরিষেবার মনোভাব:",
    name9: "পরিষেবার দক্ষতা:",
    name10: "পরিষেবার গুণমান:",
    name11: "ক্রেতা মূল্যায়ন",
    name12:"থেকে",
    name13:"বন্ধ করা হয়েছে",
    name14:"Address:"
  },
  reserSuccess: {
    // name1:
    //   "Carlcare খুলুন",
    name1: "অগ্রাধিকার পরিষেবা পেতে অনুগ্রহ করে রিসিট হিসেবে রিজার্ভেশনের তথ্যটির স্ক্রিনশট নিয়ে সেভ করে রাখুন।",
    name2: "সফলভাবে জমা করা হয়েছে",
    name3: "1. ডেটা ক্লিন করুন",
    name4: "আগের থেকেই আপনার ফোনে গুরুত্বপূর্ণ ব্যক্তিগত ডেটা ব্যাকআপ করে রাখুন",
    name5: "2. পাওয়ার-অন পাসওয়ার্ড নিষ্ক্রিয় করুন",
    name6: "পরিষেবা কেন্দ্রে যাওয়ার আগে, দয়া করে:",
    name7: "পরিষেবা স্টোর:",
    name8: "সংরক্ষণের সময়:",
    name9: "সমস্যার বিবরণ:",
    name10: "ডিভাইস মডেল:",
    name11: "অর্ডার নম্বর:", 
    name12: "তথ্য অর্ডার করুন",
  },
  title: {
    name1: "এই দেশগুলি সমর্থিত:",
    name2: "মডেল পছন্দ করুন",
    name3: "সংরক্ষণ",
    name4: "পরিষেবা স্টোরের বিবরণ",
    name5: "পরিষেবা স্টোর নির্বাচন করুন",
  },
  error: {
    name1: "কোনো ডেটা নেই। অনুগ্রহ করে আপনার মেরামতের তথ্য চেক করুন",
    name2: "আরো বেশি সাহায্যের প্রয়োজন? অনুগ্রহ করে আমাদের সাথে যোগাযোগ করুন।",
    name3: "দুঃখিত, বর্তমান অঞ্চলে কোনো Carlcare কেন্দ্র নেই।",
    name4: "অনুগ্রহ করে আগে একটি পরিষেবা কেন্দ্র বাছুন",
    name5: "ব্যর্থ হয়েছে",
    name6: "অনুগ্রহ করে আগে একটি ডিভাইস মডেল বাছুন",
    name7: "বিশদ বিবরণ",
    name8: "অনুগ্রহ করে আপনার প্রয়োজন বিশদে জানান",
    name9: "",
  },
  add1:{
    "name0": "bn-rBD",
    "name1": "আপনার অর্ডারটি নিশ্চিত করা হয়েছে। আমরা আপনার আগমনের অপেক্ষায় রয়েছি।",
    "name2": "শহর নির্বাচন করুন",
    "name3": "প্লিজ %1$s সংখ্যার একটি ফোন নম্বর ইনপুট দিন",
    "name4": "সপ্তাহের দিন ঘন্টা",
    "name5": "সোমবার",
    "name6": "মঙ্গলবার",
    "name7": "বুধবার",
    "name8": "বৃহস্পতিবার",
    "name9": "শুক্রবার",
    "name10": "শনিবার",
    "name11": "রবিবার",
    "name12": "দেশের নাম লিখুন এবং অনুসন্ধান করুন"
  },
  add2:{
    "name0": "English",
    "name1": "Repair Method：",
    "name2": "In-store Repairs",
    "name3": "Delivery service",
    "name4": "Fault Type",
    "name5": "Tap to select fault type",
    "name6": "pick-up time",
    "name7": "tap to select pick-up time",
    "name8": "pick-up address",
    "name9": "Pleasee input your house number/street/district/province",
    "name10": "Pleasee input postal code",
    "name11": "Add returning address",
    "name12": "returning address",
    "name13": "অন্যান্য",
    "name14": "Please describle your dexice problem in detail!",
    "name15": "Sending Post Code",
    "name16": "Please input your returning number/street/district/province",
    "name17": "Please input your returning code",
    "name18": "Returning Post Code",
    "name19": "Sending Address",
    "name20": "Choose your province",
  },
  coupons: {
    name1:"Coupons",
    name2:"রিডিরেক্টের জন্য ট্যাপ করুন",
    name3:"অর্ডার রেট করতে Carlcare অ্যাপ খুলুন",
    name4:"Navigate by Google Maps",
    name5:"Navigate by Yandex Maps",
    name6:"পরিষেবা নির্বাচন করুন",
    name7:"বিনামূল্যে পরিষ্কার",
    name8:"Software Upgrade",
  },
  cancelorder:{
    "cancelReason0": "ভুল তথ্য",
    "cancelReason1": "সঠিক সময়ে এসে পৌঁছাতে পারছে না",
    "cancelReason2": "নকল অর্ডার/আমার অর্ডার নয়",
    "cancelReason3": "ব্যর্থতার পুনরাবৃত্তি হয় না",
    "cancelReason4": "শুধু পরীক্ষা/অনুসন্ধান/ইভেন্ট/-এর জন্য…",
    "cancelReason5": "বেশি দাম",
    "cancelReason6": "উপাদানের ঘাটতি",
    "cancelReason7": "কোনো বিভেদমূলক পরিষেবা প্রদান করা হয় না",
    "cancelReason8": "স্টোরটি অনেক দূরে",
    "cancelReason9": "স্টোরটি বন্ধ আছে",
    "cancelReason10": "গ্রাহক পরিষেবার খারাপ ব্যবহার",
    "cancelReason11": "অন্যান্য ব্র্যান্ডের জন্য প্রতিস্থাপন করা/মেরামত করা",
    "cancelReason12": "দোকান খুঁজে পাওয়া যাচ্ছে না",
    "cancelReason13": "অন্যান্য",
    "cancelOrder": "অর্ডার বাতিল করুন",
    "reason_dialog_title": "অনুগ্রহ করে বাতিলকরণের কারণটি আমাদের বলুন",
    "Cancel": "বাতিল করুন",
    "OK": "ঠিক আছে",
    "name1": "যাচাইকরণ কোডটি লিখুন",
    "name2": "অবৈধ যাচাই কোড",
    "repair_reservation_detail_canceled": "এই অর্ডার বাতিল করা হয়েছে!",
    "purchase_cancel_dialog_content": "আপনি কি অর্ডারটি বাতিল করতে নিশ্চিত?",
    "yes": "হ্যা",
    "no": "না"
}
};
